<template>
  <div class="downloadh5" ref="downloadh5">
    <div class="introduce">
      <div class="video-box">
        <video
          src="@/assets/xiazai.mp4"
          :controls="false"
          alt=""
          ref="video"
          class="video"
        />
      </div>
    </div>
    <div class="idownload">
      <div class="text">
        <div class="t1">管理全面升级 就用<span>丰派云POS</span></div>
        <div class="t2">10000+ 企业正在使用我们的产品降本增效</div>
      </div>
      <div class="text top">
        <div class="t1">丰派云POS</div>
        <div class="t3">支持 iOS，Android，Windows，微信小程序</div>
      </div>
      <div class="id-row top">
        <div class="idr-item">
          <div class="item-con">
            <img
              src="@/assets/newdownload/appicon1.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">Windows</div>
          </div>
          <div class="item-name">PC客户端</div>
          <div class="item-dword">请访问PC端网页下载</div>
        </div>
        <div class="idr-item">
          <div class="item-con bg2">
            <img
              src="@/assets/newdownload/appicon2.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">Android</div>
          </div>
          <div class="item-name">安卓客户端</div>
          <div class="item-dword">请访问PC端网页下载</div>
        </div>
      </div>
      <div class="id-row top2">
        <div class="idr-item">
          <div class="item-con">
            <img
              src="@/assets/newdownload/appicon4.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">自助收银</div>
          </div>
          <div class="item-name">自助收银</div>
          <div class="item-dword">请访问PC端网页下载</div>
        </div>
        <div class="idr-item">
          <div class="item-con bg2">
            <div class="item-con-large">
              <img
                src="@/assets/newdownload/wxcode.png"
                alt=""
                class="item-img"
              />
            </div>
            <!-- <div class="item-word">Android</div> -->
          </div>
          <div class="item-name">收银后台小程序</div>
          <div class="item-dword">请使用微信扫码</div>
        </div>
      </div>
      <div class="id-row top2">
        <div class="idr-item bg2">
          <div class="item-con">
            <div class="item-con-large">
              <img
                src="@/assets/newdownload/showqrcode.png"
                alt=""
                class="item-img"
              />
            </div>
            <!-- <div class="item-word">Android</div> -->
          </div>
          <div class="item-name">收银手机后台APP</div>
          <div class="item-dword">Android、IOS通用</div>
          <div class="item-download" @click.stop="down">扫码/点击下载</div>
        </div>
      </div>
    </div>
    <div class="down-sale">
      <div class="ds-tit">智慧零售应用</div>
      <div class="ds-tip">支持 iOS，Android，微信小程序</div>
      <div class="ds-content">
        <div class="dsc-item">
          <div class="item-con">
            <img
              src="@/assets/newdownload/appicon66.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">开发中...</div>
          </div>
          <div class="item-name">零售商城小程序</div>
          <div class="item-dword">微信扫码体验</div>
        </div>
        <div class="dsc-item">
          <div class="item-con bg2">
            <img
              src="@/assets/newdownload/appicon3.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">开发中...</div>
          </div>
          <div class="item-name">智慧零售APP</div>
          <div class="item-dword">Android、IOS通用</div>
        </div>
      </div>
    </div>
    <div class="down-sale bg">
      <div class="ds-tit">订货</div>
      <div class="ds-tip">支持 iOS，Android，微信小程序</div>
      <div class="ds-content">
        <div class="dsc-item">
          <div class="item-con">
            <!-- <div class="item-con-large">
              <img
                src="@/assets/newdownload/ldsc.png"
                alt=""
                class="item-img"
              />
            </div> -->
            <img
              src="@/assets/newdownload/appicon66.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">开发中...</div>
          </div>
          <div class="item-name">丰派订货小程序</div>
          <div class="item-dword">微信扫码体验</div>
        </div>
        <div class="dsc-item">
          <div class="item-con bg2">
            <img
              src="@/assets/newdownload/appicon3.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">开发中...</div>
          </div>
          <div class="item-name">订货管理APP</div>
          <div class="item-dword">Android、IOS通用</div>
        </div>
      </div>
    </div>
    <!-- <div class="cashier">
      <div class="text">
        <div class="t1">收银应用</div>
        <div class="t2">支持 iOS，Android，Windows，微信小程序</div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="win" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">收银Windows客户端</div>
          <div class="t2">请访问PC模式网页</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fpsy" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">Android客户端</div>
          <div class="btn" @click="clickdownload">下载收银 Android 客户端</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="win8" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">收银管家 微信小程序</div>
          <div class="t3">请使用微信扫描二维码</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fp" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">丰派收银管家APP</div>
          <div class="btn" @click="down">下载收银管家 APP</div>
          <div class="t3">Android、iOS通用</div>
        </div>
      </div>
    </div>
    <div class="cashier cashier1">
      <div class="text">
        <div class="t1">智慧零售应用</div>
        <div class="t2">支持 iOS，Android，微信小程序</div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="win" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">收银Windows客户端</div>
          <div class="t2">请访问PC模式网页</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="ls" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">零售商城小程序</div>
          <div class="t3">请使用微信扫描二维码</div>
        </div>
      </div>
    </div>
    <div class="cashier">
      <div class="text">
        <div class="t1">订货</div>
        <div class="t2">支持 iOS，Android，微信小程序</div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fpdh" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">丰派订货小程序</div>
          <div class="t3">请使用微信扫描二维码</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fp" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">订货管理APP</div>
          <div class="btn">开发中即将上线...</div>
          <div class="t3">Android、iOS通用</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import win from "@/assets/win1.png";
import fpsy from "@/assets/fpsy.png";
import win8 from "@/assets/win8.png";
import fp from "@/assets/fp.png";
import ls from "@/assets/ls.png";
import fpdh from "@/assets/fpdh.png";

export default {
  data() {
    return {
      win,
      fpsy,
      win8,
      fp,
      ls,
      fpdh,
      time: null,
    };
  },
  activated() {
    this.play();
    this.$refs.downloadh5.scrollIntoView();
    this.$refs.video.controls = false;
  },
  methods: {
    down() {
      window.open("https://www.fp1123.com/fpPos/#/download", "_self");
    },
    play() {
      this.$refs.video.play();
      this.time = setInterval(() => {
        this.$refs.video.play();
      }, 0);
    },
    clickdownload() {
      let elink = document.createElement("a");
      elink.download = "Android版本下载";
      elink.style.display = "none";
      elink.href = "https://data.fpsc.shop/fp_pos_android/fp_pos_android.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    beforeCreate() {
      clearInterval(this.time);
      this.time = null;
    },
  },
};
</script>
<style lang="less" scoped>
.downloadh5 {
  width: 750px;
  .introduce {
    height: 478px;
    padding: 64px 15px;
    background: linear-gradient(
      180deg,
      #e8f1ff 0%,
      rgba(232, 241, 255, 0) 100%
    );
    .video-box {
      width: 720px;
      height: 478px;
      .video {
        width: 100%;
        height: 100%;
      }
      .video::-webkit-media-controls-enclosure {
        display: none;
      }
    }
  }
  .idownload {
    background: #ffffff;
    padding: 80px 0px;
    .text {
      margin-top: 24px;
      text-align: center;
      &.top {
        margin-top: 40px;
      }
      .t1 {
        font-size: 48px;
        font-weight: 700;
        line-height: 64px;
        span {
          color: #336fff;
        }
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        color: #637392;
      }
      .t3 {
        margin-top: 16px;
        font-size: 28px;
        color: #51565d;
      }
    }
    .id-row {
      display: flex;
      // align-items: center;
      justify-content: center;
      gap: 40px;
      &.top {
        margin-top: 40px;
      }
      &.top2 {
        margin-top: 80px;
      }
      .idr-item {
        width: 240px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-con {
          width: 240px;
          height: 240px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: url("~@/assets/newdownload/appback1.png");
          background-size: 100%;
          &.bg2 {
            background: url("~@/assets/newdownload/appback2.png");
            background-size: 100%;
          }
          .item-con-large {
            width: 200px;
            height: 200px;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            .item-img {
              width: 180px;
              height: 180px;
            }
          }
          .item-img {
            width: 120px;
            height: 120px;
          }
          .item-word {
            margin-top: 8px;
            font-weight: 500;
            font-size: 24px;
            line-height: 32px;
            color: #ffffff;
          }
        }
        .item-name {
          margin-top: 32px;
          font-weight: 500;
          font-size: 30px;
          line-height: 40px;
          color: #51565d;
        }
        .item-dword {
          margin-top: 16px;
          font-weight: 400;
          font-size: 24px;
          line-height: 28px;
          color: #336fff;
        }
        .item-download {
          margin-top: 16px;
          width: 240px;
          height: 80px;
          background: #336fff;
          box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
          border-radius: 8px;
          // padding: 20px 0px;
          font-weight: 400;
          font-size: 28px;
          line-height: 80px;
          color: #ffffff;
          text-align: center;
          &:active {
            background: #5c8cff;
          }
        }
      }
    }
  }
  .down-sale {
    width: 750px;
    height: 678px;
    background: #f5f7fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    &.bg {
      background: #ffffff;
    }
    .ds-tit {
      margin-top: 80px;
      font-weight: 500;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .ds-tip {
      margin-top: 20px;
      font-weight: 400;
      font-size: 28px;
      line-height: 40px;
      color: #51565d;
    }
    .ds-content {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      gap: 40px;
      .dsc-item {
        width: 240px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-con {
          width: 240px;
          height: 240px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: url("~@/assets/newdownload/appback1.png");
          background-size: 100%;
          &.bg2 {
            background: url("~@/assets/newdownload/appback2.png");
            background-size: 100%;
          }
          .item-con-large {
            width: 200px;
            height: 200px;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            .item-img {
              width: 180px;
              height: 180px;
            }
          }
          .item-img {
            width: 120px;
            height: 120px;
          }
          .item-word {
            margin-top: 8px;
            font-weight: 500;
            font-size: 24px;
            line-height: 32px;
            color: #ffffff;
          }
        }
        .item-name {
          margin-top: 32px;
          font-weight: 500;
          font-size: 30px;
          line-height: 40px;
          color: #51565d;
        }
        .item-dword {
          margin-top: 16px;
          font-weight: 400;
          font-size: 24px;
          line-height: 28px;
          color: #336fff;
        }
      }
    }
  }
  // .cashier {
  //   background: #f5f7fa;
  //   padding: 54px 0;
  //   .text {
  //     margin-top: 24px;
  //     text-align: center;
  //     margin-bottom: 40px;
  //     .t1 {
  //       font-size: 48px;
  //       font-weight: 500;
  //       line-height: 64px;
  //       color: #1f2329;
  //     }
  //     .t2 {
  //       margin-top: 20px;
  //       font-size: 28px;
  //       color: #637392;
  //     }
  //   }
  //   .app {
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: center;
  //     align-items: center;
  //     margin-bottom: 80px;
  //     .img-box {
  //       width: 280px;
  //       height: 280px;
  //       background: #ffffff;
  //       box-shadow: 4px 8px 20px 4px rgba(69, 110, 205, 0.1);
  //       border-radius: 24px;
  //       overflow: hidden;
  //       .img {
  //         width: 280px;
  //         height: 280px;
  //       }
  //     }
  //     .txt {
  //       font-size: 32px;
  //       line-height: 40px;
  //       color: #292929;
  //       font-weight: 500;
  //       margin-top: 24px;
  //       text-align: center;
  //       .t2 {
  //         margin-top: 16px;
  //         font-weight: 350px;
  //         font-size: 24px;
  //         line-height: 28px;
  //       }
  //       .t3 {
  //         margin-top: 16px;
  //         font-size: 26px;
  //         line-height: 34px;
  //         color: #336fff;
  //       }
  //       .btn {
  //         margin-top: 24px;
  //         color: #ffffff;
  //         padding: 24px 40px;
  //         background: #336fff;
  //         box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
  //         border-radius: 16px;
  //       }
  //     }
  //   }
  // }
  // .cashier1 {
  //   background: #ffffff;
  // }
}
</style>



// WEBPACK FOOTER //
// src/h5/downloadH5.vue